import { Redirect, Route, RouteComponentProps, useLocation } from "wouter";
import { ComponentType } from "react";
import { useAuthState } from "@/store/auth";
import { getDefaultRouteAfterLogin, getLoginRoute } from "@/constants";
import { useQueryParams } from "@/hooks/useQueryParams";
import env from "@/env";
import { urlWithCurrentQuery } from "@/utils";
import { isExplorerOnlyMode } from "@/utils/explorerOnlyMode";
import { isOnLoginSubdomain, redirectToLogin } from "@/utils/tool";

type AuthenticatedRouteProps = {
  path: string;
  component: ComponentType<RouteComponentProps>;
  requiresState?: unknown;
};

export const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ path, component }) => {
  const status = useAuthState((state) => state.status);
  const isReady = useAuthState((state) => state.isReady);
  const isLoggedIn = status === "authenticated";
  const [location] = useLocation();
  const query = useQueryParams<{ redirect: string }>();

  if (!isReady) {
    return null;
  }

  if (!isLoggedIn) {
    const redirect = query.redirect ?? location;

    if (env.SECTION_SUBDOMAINS_ENABLED && !isOnLoginSubdomain()) {
      redirectToLogin(redirect);
      return null;
    }

    if (isExplorerOnlyMode()) {
      return <Redirect to={urlWithCurrentQuery(getDefaultRouteAfterLogin())} />;
    }

    return (
      <Redirect
        to={urlWithCurrentQuery(getLoginRoute(), {
          ...(redirect.length > 1
            ? {
                redirect
              }
            : {})
        })}
      />
    );
  }

  return <Route path={path} component={component} />;
};
